import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ThemeService } from './core/services/theme.service';
import { Sidenav } from './shared/components/sidenav/sidenav';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Sidenav],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private readonly router = inject(Router);
  private readonly themeService = inject(ThemeService);
  readonly showSidenav = signal(true);

  constructor() {
    this.themeService.initThemeMode();
    this.updateLayoutState();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.updateLayoutState());
  }

  private updateLayoutState(): void {
    const url = this.router.url;
    const isAuthPage =
      url.startsWith('/login') ||
      url.startsWith('/forget-password') ||
      url.startsWith('/otp') ||
      url.startsWith('/verify') ||
      url.startsWith('/reset-password');

    this.showSidenav.set(!isAuthPage);
  }
}
